<template>
    <div>
        <v-data-table :headers="headers" :items="teams" mobile-breakpoint="1" disable-pagination class="mt-2"
                        hide-default-footer>
            <template v-slot:item.results.position="{ item }">
                <span v-if="item.results.position===1000">-</span>
                <span v-else-if="item.results.positionLos">{{ item.results.positionLos }}</span>
                <span v-else>{{ item.results.position }}</span>
            </template>
            <template v-slot:item.settings.name="{ item }">
                <div class="py-2">
                    {{ item.settings.name }}
                    <div v-if="item.results.kommentar || item.results.status !== 'finished'" class="error--text">
                    <span v-if="item.results.status !== 'finished'">
                        {{resultStatus.find(status => status.value === item.results.status)?.label}}</span>
                        <span v-if="item.results.kommentar"> ({{item.results.kommentar}})</span>
                    </div>
                    <v-chip small v-if="item.results.losEntscheid && !item.results.positionLos" color="primary">
                        <v-icon small class="mr-1">mdi-alert</v-icon>
                        Losentscheid erforderlich</v-chip>
                    <v-chip small v-if="item.results.positionLos" color="#666666" dark>
                        <v-icon small class="mr-1">mdi-information</v-icon>
                        Durch Los entschieden!</v-chip>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <div v-if="isOperator" class="text-no-wrap">
                    <v-btn icon @click="requestDeleteConfirm(item)" :disabled="bewerb.isConfirmed()"
                           class="mr-1"><v-icon>mdi-delete</v-icon></v-btn>
                    <v-btn icon @click="editTeamSettings(item)" :disabled="bewerb.isConfirmed()"
                           class="mr-1"><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-btn icon @click="editTeamResults(item)" :disabled="bewerb.isConfirmed()"
                           :color="item.results.status && (!item.results.losEntscheid ||
                                    (item.results.losEntscheid && item.results.positionLos))?'success':'warning'">
                        <v-icon>mdi-bowling</v-icon></v-btn>
                </div>
            </template>
        </v-data-table>
    <!-- delete entry -->
        <confirm-dialog :open="confirmDelete.open" :header="teamLabel.singular + ' löschen'"
                        @reply="processConfirm" query-parameter="confirmMeisterschaftTeamDelete">
            {{ confirmDelete.question }}
            <div>Falls du bereits Ergebnisse eingegeben hast werden diese auch gelöscht. Die Reihung wird neu berechnet.</div>
        </confirm-dialog>
    </div>
</template>

<script>
import ConfirmDialog from "@/components/navigation/confirmDialog.vue";
import {RESULT_STATUS} from "@/services/data/meisterschaften/bewerb_constants";

export default {
    name: "meisterschaftRundeTab",
    components: {ConfirmDialog},
    props: ['runde', 'bewerb', 'landesverbandId'],
    computed: {
        teamLabel(){ return this.bewerb.getTeamLabel() },
        teams(){ return this.runde.getTeamList() },
        isOperator(){ return this.$store.getters["user/isMeisterschaftOperator"](this.landesverbandId)},
    },
    data: () => ({
        headers: [
            { text: 'Pos', value: 'results.position' },
            { text: 'Name', value: 'settings.name' },
            { text: 'Verein', value: 'settings.vereinsName' },
            { text: 'LV', value: 'settings.landesverband' },
            { text: 'AK', value: 'settings.ak' },
            { text: 'Volle', value: 'results.volle' },
            { text: 'AR', value: 'results.abraeumen' },
            { text: 'FW', value: 'results.fehlwuerfe' },
            { text: 'Ges', value: 'results.gesamt' },
            { text: '', value: 'actions', sortable: false }
        ],
        confirmDelete: {
            open: false,
            question: '',
            teamId: null,
        },
        resultStatus: RESULT_STATUS
    }),
    methods: {
        editTeamSettings(team){
            this.$emit('editTeam', team)
        },
        editTeamResults(team){
            this.$emit('editRundeTabResult', team)
        },
    // delete team
        requestDeleteConfirm(team){
            this.confirmDelete.open = true;
            this.confirmDelete.question = 'Möchtest du ' + team.settings.name + ' wirklich endgültig löschen?'
            this.confirmDelete.teamId = team.id;
        },
        async processConfirm(reply) {
            if ( reply ) await this.processDeletion(this.confirmDelete.teamId);
            this.confirmDelete.open = false;
            this.confirmDelete.question = '';
            this.confirmDelete.teamId = null;
        },
        async processDeletion(teamId){
            await this.runde.deleteTeam(teamId, this.bewerb?.id)
        }
    },
}
</script>

<style scoped>

</style>